package com.narbase.narnic.trial

import com.narbase.bos.common.medico.MedicoBalsamOnePageRef
import com.narbase.bos.common.one.BalsamOnePageRef
import com.narbase.bos.common.one.ThankYouPageRef
import com.narbase.bos.common.pages.MedicoEventPageRef
import com.narbase.bos.common.whatsapp.WhatsAppPageRef
import com.narbase.kunafa.core.hydration.hydrate
import com.narbase.narnic.trial.medico.MedicoLandingPageHydrate
import com.narbase.narnic.trial.one.OneLandingPageHydrate
import com.narbase.narnic.trial.one.ThankYouPageHydrate
import com.narbase.narnic.trial.pages.MedicoEventPageHydrate
import com.narbase.narnic.trial.pages.WhatsAppPageHydrate
import kotlinx.browser.document


fun main() {

    document.head?.innerHTML += """
        
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
    """.trimIndent()

    /*

        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap" rel="stylesheet">
*/

//    println(("671").toInt())
    hydrate(BalsamOnePageRef()) {

        mainButton?.onClick = {

            mainButton?.text = "I am hydrated"

            Unit
        }

        getStartedButton?.onClick = {

        }
    }

    hydrate(MedicoBalsamOnePageRef(), MedicoLandingPageHydrate::hydrate)
    hydrate(BalsamOnePageRef(), OneLandingPageHydrate::hydrate)
    hydrate(ThankYouPageRef(), ThankYouPageHydrate::hydrate)
    hydrate(MedicoEventPageRef(), MedicoEventPageHydrate::hydrate)
    hydrate(WhatsAppPageRef(), WhatsAppPageHydrate::hydrate)

}
